import {
  CAccordion,
  CAccordionBody,
  CAccordionHeader,
  CAccordionItem,
  CButton,
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
  CFormCheck,
  CFormInput,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CFormLabel,
  CCardBody,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
} from '@coreui/react'
import React, { useEffect, useState } from 'react'
import PatientOrdersCRUD from '../../services/general/patientOrders.api'
import ImagingInformation from '../../services/general/ImagingAPI.api'
import LabCRUD from '../../services/general/LabsAPI.api'
import MedicineCRUD from '../../services/general/Medication.api'
import Select from 'react-select'
import Graytextarea from '../../components/Graytextarea'
import { File, FilePen, Trash } from 'lucide-react'
import CloudinaryUploader from '../../components/shared/CloudinaryUploader'
import SaveExtra from '../../services/general/saveExtraData.api'
import PatientImagingsCRUD from '../../services/general/patientImagingData'
import Carder from '../../components/shared/Carder'
import HighlightedText from '../../components/shared/HighlightedText'
import PatientMedications from '../../services/general/patientMedicationData.api'
import PatientLabsCRUD from '../../services/general/patientLabsCrud.api'
import DarkCloudinaryUploader from '../../components/shared/DarkCloudinaryUploader'
import CreatableSelect from 'react-select/creatable'
import { useIndexedDB } from '../../context/IndexedContext'

const AddOrders = ({ diagnosisName, patientID, noteID, toggleModal, fetchOrdersAgain, noteStructureRef = {}, patientDBData, setPatientDBData, noteCallType, allData, allMedication }) => {
  const [order, setOrders] = useState([])
  const [masterImaging, setMasterImaging] = useState([])
  const [masterMedications, setMasterMedications] = useState([])
  const [masterLabs, setMasterLabs] = useState([])
  const [masterMiscellous, setMasterMiscellous] = useState([])
  const [activeTab, setActiveTab] = useState(1)

  function formatDateToUS(dateInput) {
    const date = new Date(dateInput || new Date())

    const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0')
    const year = date.getFullYear()

    return `${month}-${day}-${year}`
  }

  // Imaging States
  const [addedImaging, setAddedImaging] = useState([])
  const [addScriptImagingIndex, setAddScriptImagingIndex] = useState(null)
  const [activeScriptTabImaging, setActiveScriptTabImaging] = useState(1)
  const [activeTabImaging, setActiveTabImaging] = useState(1)
  const [patientImaging, setPatientImaging] = useState([])

  useEffect(() => {
    const med = {
      dosageArr: ['100mg'],
      sideEffect: '',
      mechanismOfAction: '',
      maxDose: '',
      class: 'Benzodiazepine drug class',
      otherRoute: '',
      route: '',
      dosage: '',
      frequency: '',
      isScriptRequired: false,
      name: 'Klonopin',
      reason: '',
      script: [],
    }

    if (noteStructureRef?.current?.plans) {
      const hasKlonopin = Object.values(noteStructureRef.current.plans).some((plan) => plan?.medsDetails?.some((m) => m?.name === 'Klonopin'))

      if (hasKlonopin) {
        setAddedMedications((prevMedications) => {
          const alreadyExists = prevMedications?.some((med) => med.name === 'Klonopin')

          if (alreadyExists) {
            return prevMedications
          }

          return [...prevMedications, med]
        })
      } else {
        console.log(' Klonopin not found in any plan')
      }
    }
  }, [noteStructureRef, diagnosisName])

  // Medications
  const [activeTabMedication, setActiveTabMedication] = useState(1)
  const [addedMedications, setAddedMedications] = useState([])
  const [addScriptMedicationIndex, setAddScriptMedicationIndex] = useState(null)
  const [activeScriptTabMedication, setActiveScriptTabMedication] = useState(1)
  const frequencyMedication = [
    { label: 'Qd', value: 'Qd' },
    { label: 'Bid', value: 'Bid' },
    { label: 'Tid', value: 'Tid' },
    { label: 'Qid', value: 'Qid' },
    { label: 'Other', value: 'Other' },
  ]
  const routesOption = [
    { label: 'Oral', value: 'Oral' },
    { label: 'IV', value: 'IV' },
    { label: 'IM', value: 'IM' },
    { label: 'PEG', value: 'PEG' },
    { label: 'Suppository', value: 'Suppository' },
  ]

  // Labs
  const [activeTabLabs, setActiveTabLabs] = useState(1)
  const [addedLabs, setAddedLabs] = useState([])
  const [addScriptLabsIndex, setAddScriptLabsIndex] = useState(null)
  const [activeScriptTabLabs, setActiveScriptTabLabs] = useState(1)

  // miscellous
  const [addedMisc, setAddedMisc] = useState([])
  const { getImagingMasterData, getLabMasterData, getMedicationMasterData, getMiscellaneousMaster, getOfflineData, getProviderDetails, saveOfflineData, getOpenChartOfflineData, saveOpenChartOfflineData } = useIndexedDB()

  const reset = () => {
    toggleModal()
    setAddedImaging([])
    setAddedLabs([])
    setAddedMedications([])
  }

  // const fetchOrders = async () => {
  //     try {

  //         let data = await PatientOrdersCRUD('Get', "", patientID);

  //         data = JSON.parse(data?.d).Data || [];

  //         const parsedOrders = data?.map(order => ({
  //             // ...order,
  //             ...order,
  //             id: order.id,
  //             date: order.date,
  //             medication: JSON.parse(order.medication)
  //         }))
  //             .filter(item => item.medication?.diagnosis === diagnosisName && item?.medication?.noteID === noteID)

  //         setOrders(parsedOrders)

  //     } catch (error) {
  //     }
  // };

  const fetchOrders = async () => {
    try {
      let patientordersData = patientDBData?.ordersData

      const filterOrder = patientordersData.filter((item) => item.medication?.diagnosis === diagnosisName && item?.medication?.noteID === noteID)

      setOrders(filterOrder)
    } catch (error) {
      console.error('error  while fetching order data', error)
    }
  }
  const extractUniqueKeywords = (keywordsArray) => {
    const allKeywords = keywordsArray.flatMap((item) => item.keyword.split(',')).map((keyword) => keyword.trim())

    const uniqueKeywords = Array.from(new Set(allKeywords))

    return uniqueKeywords
  }

  const [imagingTypeList, setImagingTypeList] = useState([])

  // const GetPatientImagings = async () => {
  //     try {
  //         let formattedData = await PatientImagingsCRUD("GET", patientID.toString());
  //         if (formattedData) {
  //             formattedData = JSON.parse(formattedData.d);
  //             formattedData = formattedData.Data.map(item => {
  //                 const parsedData = JSON.parse(item.data);
  //                 const matchingType = parsedData && imagingTypeList.find((type) => {
  //                     return type.Name.toString() === parsedData.name.toString();
  //                 });
  //                 return {
  //                     ...item,
  //                     data: {
  //                         ...parsedData,
  //                         keywords: matchingType ? extractUniqueKeywords(matchingType.Keywords) : []
  //                     }
  //                 };
  //             });
  //             formattedData.sort((a, b) => new Date(b?.date) - new Date(a?.date));

  //             setPatientImaging(formattedData);
  //             return formattedData;
  //         }
  //     } catch (error) {
  //         console.error("Error fetching patient imaging data", error);
  //     }
  // };

  const GetPatientImagings = async () => {
    try {
      let patientallImaging = patientDBData?.allImaging
      setPatientImaging(patientallImaging)
      return patientallImaging
    } catch (error) {
      console.error('Error fetching patient imaging data', error)
    }
  }

  const getImagingData = async () => {
    try {
      const allImaging = await getImagingMasterData()
      setMasterImaging(allImaging || [])
      // const data = await ImagingInformation("GET_ALL");
      // if (data) {
      //     const formattedData = JSON.parse(data.d)?.Data;
      //     const allFormattedData = formattedData.map((item) => {
      //         return {
      //             ID: item.ID,
      //             Name: item.Name
      //         }
      //     })
      //     setMasterImaging(allFormattedData)
      // }
    } catch (error) {}
  }

  const getLabData = async () => {
    try {
      const labData = await getLabMasterData()
      // let labData = await LabCRUD("GETALL", "{}");
      // labData = JSON.parse(labData.d)?.Data;
      // Simulate fetching data

      setMasterLabs(labData)
    } catch (error) {}
  }

  const getMedicationData = async () => {
    // let allMedicines = await MedicineCRUD("GET")
    // let formattedData
    // formattedData = JSON.parse(allMedicines.d)?.Data;
    // formattedData = formattedData.map(item => {
    //     const data = JSON.parse(item.Data);
    //     return {
    //         ...data,
    //     };
    // });

    const allMedication = await getMedicationMasterData()
    if (allMedication) {
      setMasterMedications(allMedication || [])
    }
  }

  const [medicationList, setMedicationList] = useState([])

  // const fetchMedications = async () => {
  //     let formattedData
  //     formattedData = await PatientMedications("GET", patientID.toString());
  //     formattedData = JSON.parse(formattedData.d)
  //     formattedData = formattedData?.Data
  //     if (formattedData) {
  //         formattedData = formattedData.map((item) => {
  //             return {
  //                 ...item,
  //                 data: JSON.parse(item.data)
  //             }
  //         })
  //     }
  //     formattedData.sort((a, b) => new Date(b?.date) - new Date(a?.date));

  //     setMedicationList(formattedData)
  //     return formattedData
  // };

  const fetchMedications = async () => {
    let patientallMedications = patientDBData?.allMedications

    setMedicationList(patientallMedications)
    return patientallMedications
  }
  useEffect(() => {
    fetchMedications()
  }, [])

  const [allLabs, setAllLabs] = useState([])

  // const fetchPatientLabs = async () => {
  //     try {
  //         let formattedData
  //         formattedData = await PatientLabsCRUD('GET', patientID.toString());
  //         formattedData = JSON.parse(formattedData.d)
  //         formattedData = formattedData?.Data || []
  //         if (formattedData) {
  //             formattedData = formattedData?.map((item) => {
  //                 return {
  //                     ...item,
  //                     data: JSON.parse(item.data)
  //                 }
  //             })
  //         }
  //         formattedData.sort((a, b) => b.id - a.id);
  //         setAllLabs(formattedData)
  //         return formattedData
  //     } catch (error) {
  //         console.log(error)
  //     }
  // }

  const fetchPatientLabs = async () => {
    try {
      const patientLabData = patientDBData?.patientLabData

      setAllLabs(patientLabData)
      return patientLabData
    } catch (error) {
      console.log(error)
    }
  }
  // patient labs ============
  useEffect(() => {
    fetchPatientLabs()
  }, [])

  const getTrreatmentData = async () => {
    // const data = await SaveExtra('Get_By_Type', "Miscellaneous", "", "")
    // let formattedData = JSON.parse(data?.d)?.Data;
    // formattedData = formattedData.map(item => {
    //     const data = JSON.parse(item.JsonData);
    //     return {
    //         Id: item.Id,
    //         ...data,
    //     };
    // });

    const allMiscellaneousData = await getMiscellaneousMaster()

    setMasterMiscellous(allMiscellaneousData)
  }
  const handleCloudinaryUpload = (url, type, fileName, id, publicId) => {
    setAddedImaging((prev) => {
      const updated = [...prev]

      if (!updated[addScriptImagingIndex]) return prev

      updated[addScriptImagingIndex] = {
        ...updated[addScriptImagingIndex],
        script: [...updated[addScriptImagingIndex].script, url],
      }

      return updated
    })
  }

  useEffect(() => {
    getImagingData()
    getLabData()
    getMedicationData()
    GetPatientImagings()
    getTrreatmentData()
  }, [])

  useEffect(() => {
    fetchOrders()
  }, [patientDBData])

  const getMergedImaging = (orderImaging = [], addedImaging = []) => {
    const addedTypes = addedImaging.map((item) => item.type)

    const filteredOrder = orderImaging.filter((item) => !addedTypes.includes(item.type))

    return [...filteredOrder, ...addedImaging]
  }

  const getMergedLabs = (orderlabs = [], addedLabs = []) => {
    const addedLabNames = addedLabs.map((item) => item.lab)

    const filteredOrderLabs = orderlabs.filter((item) => !addedLabNames.includes(item.lab))

    return [...filteredOrderLabs, ...addedLabs]
  }

  const getMergedMedications = (orderMeds = [], addedMedications = []) => {
    const addedNames = addedMedications.map((item) => item.name)

    const filteredOrderMeds = orderMeds.filter((item) => !addedNames.includes(item.name))

    return [...filteredOrderMeds, ...addedMedications]
  }

  // const handleSubmit = async () => {
  //     const todayDate = formatDateToUS()
  //     if (order.length > 0) {
  //         const orderId = order[0]?.id
  //         const orderMeds = order[0]?.medication?.medication?.medication
  //         const orderlabs = order[0]?.medication?.lab?.labs
  //         const orderImaging = order[0]?.medication?.imaging?.imagingTypes
  //         const orderMisc = order[0]?.medication?.miscellaneous?.miscellaneous

  //         const mergedImaging = getMergedImaging(orderImaging, addedImaging);
  //         const mergedLabs = getMergedLabs(orderlabs, addedLabs);
  //         const mergedMedications = getMergedMedications(orderMeds, addedMedications);

  //         const data = {
  //             diagnosis: diagnosisName,
  //             imaging: {
  //                 imagingTypes: mergedImaging,
  //             },
  //             medication: {
  //                 medication: mergedMedications.map(({ dosageArr, sideEffect, mechanismOfAction, class: medClass, maxDose, therapeuticLevels, otherRoute, ...rest }) => rest),
  //             },
  //             miscellaneous: {
  //                 miscellaneous: Array.from(new Set([...orderMisc, ...addedMisc]))
  //             },
  //             lab: {
  //                 labs: mergedLabs
  //             },
  //             noteID: noteID
  //         }
  //         let response = await PatientOrdersCRUD('UPDATE', orderId?.toString(), patientID, todayDate, JSON.stringify(data), "", "");
  //         reset()
  //         await fetchOrdersAgain()
  //     }
  //     else {
  //         const data = {
  //             diagnosis: diagnosisName,
  //             imaging: {
  //                 imagingTypes: addedImaging,
  //             },
  //             medication: {
  //                 medication: addedMedications.map(({ dosageArr, sideEffect, mechanismOfAction, class: medClass, maxDose, therapeuticLevels, otherRoute, ...rest }) => rest),
  //             },
  //             miscellaneous: {
  //                 miscellaneous: addedMisc
  //             },
  //             lab: {
  //                 labs: addedLabs
  //             },
  //             noteID: noteID
  //         }
  //         let response = await PatientOrdersCRUD('INSERT', "", patientID, todayDate, JSON.stringify(data), "", "");
  //         reset()
  //         await fetchOrdersAgain()
  //     }
  // }

  const addedOrderdata = async (order, today) => {
    const data = noteCallType === 'OpenChart' ? await getOpenChartOfflineData() : await getOfflineData()
    const loggedUser = await getProviderDetails()
    const loggedUserID = loggedUser?.ID
    const userData = { ...(data[loggedUserID] || {}) }
    const patientData = { ...(userData[patientID] || {}) }
    const existingOrder = patientData.ordersData || []
    const newlyAddedData = patientData.newlyAddedData || []
    const newlyAddedOrder = patientData?.newlyAddedData?.ordersData || []

    const tempOrderId = Math.floor(100 + Math.random() * 900)

    const newOrder = {
      date: today,
      id: tempOrderId,
      medication: order,
    }
    const updatedPatientData = {
      ...patientData,
      ordersData: [...existingOrder, newOrder],
      newlyAddedData: { ...newlyAddedData, ordersData: [...newlyAddedOrder, newOrder] },
    }

    const updatedUserData = {
      ...userData,
      [patientID]: updatedPatientData,
    }

    const updatedData = {
      ...data,
      [loggedUserID]: updatedUserData,
    }

    noteCallType === 'OpenChart' ? await saveOpenChartOfflineData(updatedData) : await saveOfflineData(updatedData)

    setPatientDBData(updatedPatientData)
  }

  const updateOrderdata = async (order, orderid, today) => {
    const data = noteCallType === 'OpenChart' ? await getOpenChartOfflineData() : await getOfflineData()
    const loggedUser = await getProviderDetails()
    const loggedUserID = loggedUser?.ID
    const userData = { ...(data[loggedUserID] || {}) }
    const patientData = { ...(userData[patientID] || {}) }
    const existingOrder = patientData.ordersData || []
    const newlyAddedData = patientData.newlyAddedData || []
    const newlyAddedOrder = patientData?.newlyAddedData?.ordersData || []

    const updateOrder = {
      date: today,
      id: orderid,
      medication: order,
      shouldUpdate: true,
    }

    const updateOrders = existingOrder.map((item) => {
      if (item.id === orderid) {
        return updateOrder
      }
      return item
    })

    const updateNewlyOrders = newlyAddedOrder.map((item) => {
      if (item.id === orderid) {
        return updateOrder
      }
      return item
    })

    const updatedPatientData = {
      ...patientData,
      ordersData: updateOrders,
      newlyAddedData: { ...newlyAddedData, ordersData: updateNewlyOrders.length > 0 ? updateNewlyOrders : [...newlyAddedOrder, updateOrder] },
    }

    const updatedUserData = {
      ...userData,
      [patientID]: updatedPatientData,
    }

    const updatedData = {
      ...data,
      [loggedUserID]: updatedUserData,
    }

    noteCallType === 'OpenChart' ? await saveOpenChartOfflineData(updatedData) : await saveOfflineData(updatedData)

    setPatientDBData(updatedPatientData)
  }

  const handleSubmit = async () => {
    const todayDate = formatDateToUS()
    if (order.length > 0) {
      const orderId = order[0]?.id
      const orderMeds = order[0]?.medication?.medication?.medication
      const orderlabs = order[0]?.medication?.lab?.labs
      const orderImaging = order[0]?.medication?.imaging?.imagingTypes
      const orderMisc = order[0]?.medication?.miscellaneous?.miscellaneous

      const mergedImaging = getMergedImaging(orderImaging, addedImaging)
      const mergedLabs = getMergedLabs(orderlabs, addedLabs)
      const mergedMedications = getMergedMedications(orderMeds, addedMedications)

      const data = {
        diagnosis: diagnosisName,
        imaging: {
          imagingTypes: mergedImaging,
        },
        medication: {
          medication: mergedMedications.map(({ dosageArr, sideEffect, mechanismOfAction, class: medClass, maxDose, therapeuticLevels, otherRoute, ...rest }) => rest),
        },
        miscellaneous: {
          miscellaneous: Array.from(new Set([...orderMisc, ...addedMisc])),
        },
        lab: {
          labs: mergedLabs,
        },
        noteID: noteID,
      }

      await updateOrderdata(data, orderId, todayDate)

      // let response = await PatientOrdersCRUD('UPDATE', orderId?.toString(), patientID, todayDate, JSON.stringify(data), '', '')
      reset()
      await fetchOrdersAgain()
    } else {
      const data = {
        diagnosis: diagnosisName,
        imaging: {
          imagingTypes: addedImaging,
        },
        medication: {
          medication: addedMedications.map(({ dosageArr, sideEffect, mechanismOfAction, class: medClass, maxDose, therapeuticLevels, otherRoute, ...rest }) => rest),
        },
        miscellaneous: {
          miscellaneous: addedMisc,
        },
        lab: {
          labs: addedLabs,
        },
        noteID: noteID,
      }
      await addedOrderdata(data, todayDate)
      // let response = await PatientOrdersCRUD('INSERT', '', patientID, todayDate, JSON.stringify(data), '', '')
      reset()
      await fetchOrdersAgain()
    }
  }
  const userData = JSON.parse(localStorage.getItem('user'))
  const role = userData?.Role

  // populating the order added
  useEffect(() => {
    if (order.length > 0) {
      const orderId = order[0]?.id
      const orderMeds = order[0]?.medication?.medication?.medication || allMedication
      const orderlabs = order[0]?.medication?.lab?.labs
      const orderImaging = order[0]?.medication?.imaging?.imagingTypes
      const orderMisc = order[0]?.medication?.miscellaneous?.miscellaneous

      const updatedOrderMeds = orderMeds
        .map((order) => {
          const matched = masterMedications.filter((item) => item.name).find((med) => med.name === order.name)
          if (matched) {
            return {
              ...order,
              dosageArr: matched?.dosage,
              sideEffect: matched?.sideEffect,
              mechanismOfAction: matched?.mechanismOfAction,
              maxDose: matched?.maxDose,
              therapeuticLevels: matched?.therapeuticlevels,
              class: matched?.class,
              otherRoute: matched?.otherRoute,
              dosageArr: matched.dosage, // assuming this is the array you want
            }
          }
          return null
        })
        .filter(Boolean) // removes unmatched/null entries

      if (updatedOrderMeds.length > 0) {
        setAddedMedications(updatedOrderMeds)
      }

      setAddedLabs(orderlabs)
      setAddedImaging(orderImaging)
      setAddedMisc(orderMisc)
    } else if (allMedication) {
      const orderMeds = allMedication

      const updatedOrderMeds = orderMeds
        .map((order) => {
          const matched = masterMedications.filter((item) => item.name).find((med) => med.name === order.name)
          if (matched) {
            return {
              ...order,
              dosageArr: matched?.dosage,
              sideEffect: matched?.sideEffect,
              mechanismOfAction: matched?.mechanismOfAction,
              maxDose: matched?.maxDose,
              therapeuticLevels: matched?.therapeuticlevels,
              class: matched?.class,
              otherRoute: matched?.otherRoute,
              dosageArr: matched.dosage, // assuming this is the array you want
            }
          }
          return null
        })
        .filter(Boolean) // removes unmatched/null entries

      if (updatedOrderMeds.length > 0) {
        setAddedMedications(updatedOrderMeds)
      }
    }
  }, [order, masterMedications])

  const handleDeleteMedication = (index) => {
    const updatedAddedMedications = [...addedMedications]
    updatedAddedMedications.splice(index, 1)
    setAddedMedications(updatedAddedMedications)
  }

  return (
    <>
      <div
        style={{
          backgroundColor: '#282828',
          color: 'white',
          borderRadius: '10px 10px 0 0',
        }}
        className="py-3 text-center"
      >
        {diagnosisName}
      </div>
      <CModalBody
        style={{
          backgroundColor: '#282828',
          color: 'white',
        }}
      >
        <div>
          <div className="d-flex gap-2 align-items-start">
            <div
              style={{
                height: '500px',

                borderRight: '1px solid #444',

                backgroundColor: '#282828',

                color: 'white',

                padding: '20px 16px',

                display: 'flex',

                flexDirection: 'column',

                gap: '12px',
              }}
            >
              {[
                { id: 1, label: 'Imaging' },

                { id: 2, label: 'Medication' },

                { id: 3, label: 'Labs' },

                { id: 4, label: 'Miscellaneous' },
              ].map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  style={{
                    padding: '16px 20px',

                    backgroundColor: activeTab === tab.id ? '#484848' : 'transparent',

                    color: 'white',

                    border: 'none',

                    borderRadius: '12px',

                    fontSize: '16px',

                    fontWeight: '500',

                    cursor: 'pointer',

                    textAlign: 'center',

                    transition: 'all 0.2s ease',

                    outline: 'none',
                  }}
                  onMouseEnter={(e) => {
                    if (activeTab !== tab.id) {
                      e.target.style.backgroundColor = '#333'
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (activeTab !== tab.id) {
                      e.target.style.backgroundColor = 'transparent'
                    }
                  }}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            <div
              style={{
                width: '80%',
              }}
            >
              <CTabContent>
                <CTabPane className="px-3 order-tab-content" role="tabpanel" aria-labelledby="home-tab" visible={activeTab === 1}>
                  <div className="d-flex gap-2 justify-content-center">
                    <div
                      onClick={() => setActiveTabImaging(1)}
                      style={{
                        cursor: 'pointer',
                        backgroundColor: activeTabImaging === 1 ? '#4363F2' : '#282828',
                        border: '1px solid #989898',
                        padding: '5px 14px',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                        color: '#fff',
                        fontWeight: '500',
                        fontSize: '14px',
                        boxShadow: 'none',
                        width: '100px',
                      }}
                    >
                      Add
                    </div>

                    <div
                      onClick={() => setActiveTabImaging(2)}
                      style={{
                        cursor: 'pointer',
                        backgroundColor: activeTabImaging === 2 ? '#4363F2' : '#282828',
                        border: '1px solid #989898',
                        padding: '5px 14px',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                        color: '#fff',
                        fontWeight: '500',
                        fontSize: '14px',
                        boxShadow: 'none',
                        width: '100px',
                      }}
                    >
                      List
                    </div>
                  </div>

                  <CTabContent className="p-2">
                    <CTabPane role="tabpanel" aria-labelledby="home-tab" visible={activeTabImaging === 1}>
                      <div className="w-100 d-flex flex-column gap-2 " style={{ overflow: 'scroll', height: '65vh' }}>
                        <div className="">
                          <p className="p-0 mb-2">Imaging</p>
                          <Select
                            isMulti={true}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                backgroundColor: '#191919',
                                borderColor: state.isFocused ? '#444' : '#444',
                                borderRadius: '6px',
                                boxShadow: 'none',
                                '&:hover': {
                                  borderColor: '#444',
                                },
                              }),
                              menu: (base) => ({
                                ...base,
                                backgroundColor: '#000',
                                borderRadius: '6px',
                              }),
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected
                                  ? '#191919' // blue for selected
                                  : state.isFocused
                                    ? '#2a2a2a'
                                    : '#000',
                                color: 'white',
                                cursor: 'pointer',
                                padding: '12px 14px',
                                borderBottom: '1px solid #333',
                                ':last-of-type': {
                                  borderBottom: 'none',
                                },
                                ':active': {
                                  backgroundColor: '#2a2a2a',
                                },
                              }),
                              multiValue: (base) => ({
                                ...base,
                                backgroundColor: '#191919',
                                borderRadius: '4px',
                                border: '1px solid #454545ff',
                              }),
                              multiValueLabel: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              multiValueRemove: (base) => ({
                                ...base,
                                color: 'white',
                                ':hover': {
                                  backgroundColor: '#333',
                                  color: 'white',
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              placeholder: (base) => ({
                                ...base,
                                color: '#aaa',
                              }),

                              input: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              dropdownIndicator: (base) => ({
                                ...base,
                                color: 'white',
                                ':hover': { color: 'white' },
                              }),
                            }}
                            options={masterImaging.map((item) => ({
                              value: item.ID,
                              label: item.Name,
                            }))}
                            value={addedImaging
                              .map((img) => {
                                const match = masterImaging.find((m) => m.Name === img.type)
                                return match ? { value: match.ID, label: match.Name } : null
                              })
                              .filter(Boolean)}
                            onChange={(selectedOptions) => {
                              setAddedImaging((prevImaging) => {
                                const selectedLabels = selectedOptions.map((item) => item.label)

                                const retained = prevImaging.filter((img) => selectedLabels.includes(img.type))

                                const retainedTypes = retained.map((img) => img.type)
                                const newItems = selectedLabels
                                  .filter((label) => !retainedTypes.includes(label))
                                  .map((label) => ({
                                    type: label,
                                    isScriptRequired: false,
                                    reason: '',
                                    script: [],
                                  }))

                                return [...retained, ...newItems]
                              })
                            }}
                            placeholder="Select Imaging"
                            className="w-100"
                          />
                        </div>
                        <div className={`  ${role == 'provider' ? 'accordion-dark' : ' '}  `}>
                          <CAccordion flush className="transparentAccordion">
                            {addedImaging.map((item, index) => {
                              return (
                                <CAccordionItem className="mt-2">
                                  <CAccordionHeader>{item.type}</CAccordionHeader>
                                  <CAccordionBody>
                                    <div>
                                      <div>
                                        <div className="d-flex align-items-center gap-2">
                                          <CFormCheck
                                            checked={item.isScriptRequired}
                                            onChange={(e) => {
                                              const updatedImaging = [...addedImaging]
                                              updatedImaging[index].isScriptRequired = e.target.checked
                                              setAddedImaging(updatedImaging)
                                            }}
                                            id={`isScriptRequired${index}`}
                                            label="Does this requires a script?"
                                          />
                                          <FilePen
                                            onClick={() => {
                                              setAddScriptImagingIndex(index)
                                            }}
                                            strokeWidth={2}
                                            size={15}
                                          />
                                        </div>
                                        <p>Reason -</p>
                                        <Graytextarea
                                          value={item.reason}
                                          onChange={(e) => {
                                            const updatedImaging = [...addedImaging]
                                            updatedImaging[index].reason = e.target.value
                                            setAddedImaging(updatedImaging)
                                          }}
                                          height="100px"
                                        />
                                      </div>
                                    </div>
                                  </CAccordionBody>
                                </CAccordionItem>
                              )
                            })}
                          </CAccordion>
                        </div>
                        <CModal visible={addScriptImagingIndex !== null} onClose={() => setAddScriptImagingIndex(null)}>
                          {/* <CModalHeader>
                                            <CModalTitle>React Modal title</CModalTitle>
                                        </CModalHeader> */}
                          <CModalBody
                            style={{
                              background: '#191919',
                              borderRadius: '10px 10px 0 0',
                            }}
                          >
                            <CNav variant="pills" role="tablist">
                              {/* <CNavItem>
                                  <CNavLink active={activeScriptTabImaging === 1} onClick={() => setActiveScriptTabImaging(1)}>
                                    Script
                                  </CNavLink>
                                </CNavItem> */}
                              {/* <CNavItem> */}
                              {/* <CNavLink active={activeScriptTabImaging === 2} onClick={() => setActiveScriptTabImaging(2)}>
                                                                Example
                                                            </CNavLink> */}
                              {/* </CNavItem> */}
                            </CNav>
                            <CTabContent>
                              <CTabPane role="tabpanel" aria-labelledby="home-tab" visible={activeScriptTabImaging === 1}>
                                <div className="mt-4">
                                  <DarkCloudinaryUploader
                                    onDelete={(id, fileObj) => {
                                      console.log()
                                    }}
                                    onUploadSuccess={handleCloudinaryUpload}
                                  />
                                  <div className="d-flex items-center gap-3 mt-4  ">
                                    {addedImaging[addScriptImagingIndex]?.script &&
                                      addedImaging[addScriptImagingIndex]?.script.length > 0 &&
                                      addedImaging[addScriptImagingIndex]?.script.map((fileUrl, fileIdx) => {
                                        const extension = fileUrl.split('.').pop()?.toLowerCase()
                                        const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)
                                        const isVideo = ['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(extension)
                                        const isDocument = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(extension)
                                        return (
                                          <div key={fileIdx} className="d-flex flex-column gap-2 align-items-center">
                                            <a
                                              href={fileUrl}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              className="shadow rounded p-2 position-relative d-block bg-white"
                                              style={{
                                                width: '100px',
                                                height: '100px',
                                                overflow: 'hidden',
                                                borderRadius: '8px',
                                                cursor: 'pointer',

                                                textDecoration: 'none',
                                              }}
                                            >
                                              {isVideo ? (
                                                <video
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    borderRadius: '8px',
                                                  }}
                                                  controls
                                                >
                                                  <source src={fileUrl} type="video/mp4" />
                                                </video>
                                              ) : isImage ? (
                                                <img
                                                  src={fileUrl}
                                                  alt="Uploaded"
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    borderRadius: '8px',
                                                  }}
                                                />
                                              ) : isDocument ? (
                                                <iframe
                                                  src={fileUrl}
                                                  title="Document Viewer"
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    border: 'none',
                                                    borderRadius: '8px',
                                                    pointerEvents: 'none',
                                                  }}
                                                />
                                              ) : (
                                                <div
                                                  className="text-center"
                                                  style={{
                                                    color: '#fff',
                                                    fontSize: '0.75rem',
                                                    padding: '10px',
                                                  }}
                                                >
                                                  Unknown File
                                                </div>
                                              )}
                                            </a>
                                          </div>
                                        )
                                      })}
                                  </div>
                                </div>
                              </CTabPane>
                              <CTabPane role="tabpanel" aria-labelledby="profile-tab" visible={activeScriptTabImaging === 2}>
                                Food truck fixie locavore, accusamus mcsweeney&#39;s marfa nulla single-origin coffee squid. Exercitation +1 labore velit, blog sartorial PBR leggings next level wes anderson artisan four loko farm-to-table craft beer twee. Qui photo booth letterpress, commodo enim
                                craft beer mlkshk aliquip jean shorts ullamco ad vinyl cillum PBR. Homo nostrud organic, assumenda labore aesthetic magna delectus mollit. Keytar helvetica VHS salvia yr, vero magna velit sapiente labore stumptown. Vegan fanny pack odio cillum wes anderson 8-bit,
                                sustainable jean shorts beard ut DIY ethical culpa terry richardson biodiesel. Art party scenester stumptown, tumblr butcher vero sint qui sapiente accusamus tattooed echo park.
                              </CTabPane>
                            </CTabContent>
                          </CModalBody>
                          <CModalFooter
                            style={{
                              backgroundColor: '#191919',
                              borderTop: '1px solid gray',
                              display: 'flex',
                              justifyContent: 'center',
                              gap: '10px',
                              padding: '10px',
                              borderRadius: '0 0 10px 10px',
                            }}
                          >
                            <CButton variant="outline" onClick={() => setAddScriptImagingIndex(null)} color="secondary">
                              Close
                            </CButton>
                          </CModalFooter>
                        </CModal>
                      </div>
                    </CTabPane>
                    <CTabPane className="" role="tabpanel" aria-labelledby="home-tab" visible={activeTabImaging === 2}>
                      <div
                        style={{
                          height: '65vh',
                          overflow: 'auto',
                          background: '#282828',
                        }}
                      >
                        <div>
                          <p>Existing Imaging</p>
                          <div>
                            {patientImaging?.map((imgEntry, index) => {
                              return (
                                <div key={index} style={{ borderRadius: '1rem', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', background: '#282828' }} className="mt-3 overflow-hidden">
                                  <CCardBody>
                                    <div className="mb-3">
                                      Date:{' '}
                                      {new Date(imgEntry.date).toLocaleDateString('en-US', {
                                        month: '2-digit',
                                        day: '2-digit',
                                        year: 'numeric',
                                      })}
                                    </div>
                                    <div>
                                      <div className="mb-2">
                                        <strong>Imaging Type:</strong> {imgEntry.data?.name}
                                      </div>
                                      <div className="mb-3">
                                        <strong>Impression:</strong>
                                        <div className="  p-2">
                                          <HighlightedText text={imgEntry?.data?.impression} keywords={imgEntry?.data?.keywords}></HighlightedText>
                                        </div>
                                      </div>
                                      {/* <div className="mb-3">Comment: {imgEntry?.data?.comment}</div> */}
                                    </div>
                                  </CCardBody>
                                </div>
                              )
                            })}
                          </div>
                        </div>
                        <div className="mt-4">
                          <p>Existing Orders</p>
                          <div>
                            <div className="  rounded   ">
                              {order?.length > 0 ? (
                                order.map((item, idx) => {
                                  const currentOrder = item?.medication
                                  return (
                                    <div key={idx} className="mb-3">
                                      <div className="card shadow-sm " style={{ background: '#282828', border: '1px solid gray' }}>
                                        <div className="card-body">
                                          {/* Date */}
                                          <div className="">
                                            <div>
                                              <CFormLabel className="me-2 fw-bold">Date :</CFormLabel>
                                              {(() => {
                                                const rawDate = item?.date
                                                if (!rawDate) return ''

                                                const parts = rawDate.split('-')
                                                if (parts.length !== 3) return ''

                                                const [day, month, year] = parts

                                                // Check for numeric validity
                                                if (isNaN(Number(day)) || isNaN(Number(month)) || isNaN(Number(year))) return ''

                                                // Month in JS is 0-based when using `new Date(year, monthIndex, day)`
                                                const date = new Date(Number(year), Number(month) - 1, Number(day))

                                                if (isNaN(date.getTime())) return '' // Invalid date

                                                return new Intl.DateTimeFormat('en-US', {
                                                  day: '2-digit',
                                                  month: '2-digit',
                                                  year: 'numeric',
                                                }).format(date)
                                              })()}
                                            </div>
                                            {currentOrder?.diagnosis && (
                                              <p className="mb-1 " style={{ marginTop: '-8px' }}>
                                                <strong>Diagnosis:</strong> {currentOrder.diagnosis}
                                              </p>
                                            )}
                                          </div>

                                          {/* Imaging */}
                                          {currentOrder?.imaging?.imagingTypes?.length > 0 && (
                                            <div className="mb-2">
                                              <p className="text-secondary fw-bold mb-1">Imaging</p>
                                              <ul>
                                                {currentOrder.imaging.imagingTypes
                                                  ?.filter((item) => item?.type)
                                                  .map((imagingItem, iIdx) => (
                                                    <li className="p-0 m-0" key={iIdx}>
                                                      {imagingItem?.type}
                                                    </li>
                                                  ))}
                                              </ul>
                                            </div>
                                          )}

                                          {/* {currentOrder?.lab?.labs?.length > 0 && (
                                                                                                <div className="mb-2">
                                                                                                    <p className="text-secondary fw-bold mb-1">Labs</p>
                                                                                                    <ul>
                                                                                                        {currentOrder.lab.labs.map((labItem, lIdx) => (
                                                                                                            <li className="p-0 m-0" key={lIdx}>
                                                                                                                {labItem?.lab}
                                                                                                                {labItem?.reason && ` - Reason for ${labItem.lab}: ${labItem.reason}`}
                                                                                                            </li>
                                                                                                        ))}
                                                                                                    </ul>
                                                                                                </div>
                                                                                            )}
                                                    
                                                                                            {currentOrder?.medication?.medication?.length > 0 && (
                                                                                                <div className="mb-2">
                                                                                                    <p className="text-secondary fw-bold mb-1">Medications</p>
                                                                                                    <ul>
                                                                                                        {currentOrder.medication.medication.map((medItem, mIdx) => (
                                                                                                            <li className="p-0 m-0" key={mIdx}>
                                                                                                                {medItem?.name} {medItem?.dosage} {medItem?.route}
                                                                                                                {medItem?.frequency && ` ${medItem.frequency}`}
                                                                                                                {medItem?.reason && ` - ${medItem.reason}`}
                                                                                                            </li>
                                                                                                        ))}
                                                                                                    </ul>
                                                                                                </div>
                                                                                            )}
                                                    
                                                                                            {currentOrder?.miscellaneous?.miscellaneous?.length > 0 && (
                                                                                                <div className="mb-2">
                                                                                                    <p className="text-secondary fw-bold mb-1">Miscellaneous</p>
                                                                                                    <ul>
                                                                                                        {currentOrder.miscellaneous.miscellaneous.map((miscItem, xIdx) => (
                                                                                                            <li className="p-0 m-0" key={xIdx}>
                                                                                                                {miscItem}
                                                                                                            </li>
                                                                                                        ))}
                                                                                                    </ul>
                                                                                                </div>
                                                                                            )} */}
                                        </div>
                                      </div>
                                    </div>
                                  )
                                })
                              ) : (
                                <div className="text-center text-muted py-3">No orders available.</div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </CTabPane>
                  </CTabContent>
                </CTabPane>
                <CTabPane className="px-3 order-tab-content" role="tabpanel" aria-labelledby="home-tab" visible={activeTab === 2}>
                  <div className="d-flex gap-2 justify-content-center">
                    <div
                      onClick={() => setActiveTabMedication(1)}
                      style={{
                        cursor: 'pointer',
                        backgroundColor: activeTabMedication === 1 ? '#4363F2' : '#282828',
                        border: '1px solid #989898',
                        padding: '5px 14px',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                        color: '#fff',
                        fontWeight: '500',
                        fontSize: '14px',
                        boxShadow: 'none',
                        width: '100px',
                      }}
                    >
                      Add
                    </div>

                    <div
                      onClick={() => setActiveTabMedication(2)}
                      style={{
                        cursor: 'pointer',
                        backgroundColor: activeTabMedication === 2 ? '#4363F2' : '#282828',
                        border: '1px solid #989898',
                        padding: '5px 14px',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                        color: '#fff',
                        fontWeight: '500',
                        fontSize: '14px',
                        boxShadow: 'none',
                        width: '100px',
                      }}
                    >
                      List
                    </div>
                  </div>
                  <CTabContent className="p-2">
                    <CTabPane role="tabpanel" aria-labelledby="home-tab" visible={activeTabMedication === 1}>
                      <div className="w-100 d-flex flex-column gap-2 " style={{ overflow: 'scroll', height: '65vh' }}>
                        <div className="w-100">
                          <p className="p-0 mb-2">Medication</p>
                          <CreatableSelect
                            isMulti={true}
                            options={masterMedications?.map((item) => ({
                              value: item.id,
                              label: item.name,
                              ...item,
                            }))}
                            onCreateOption={(option) => {
                              const newMed = {
                                dosageArr: [],
                                sideEffect: '',
                                mechanismOfAction: '',
                                maxDose: '',
                                therapeuticLevels: '',
                                class: '',
                                otherRoute: '',
                                route: '',
                                dosage: '',
                                frequency: '',
                                isScriptRequired: false,
                                name: option,
                                reason: '',
                                script: [],
                                isCustom: true,
                              }
                              setAddedMedications((prev) => [...prev, newMed])
                            }}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                backgroundColor: '#191919',
                                borderColor: state.isFocused ? '#444' : '#444',
                                borderRadius: '6px',
                                boxShadow: 'none',
                                '&:hover': {
                                  borderColor: '#444',
                                },
                              }),
                              menu: (base) => ({
                                ...base,
                                backgroundColor: '#000',
                                borderRadius: '6px',
                              }),
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected
                                  ? '#191919' // blue for selected
                                  : state.isFocused
                                    ? '#2a2a2a'
                                    : '#000',
                                color: 'white',
                                cursor: 'pointer',
                                padding: '12px 14px',
                                borderBottom: '1px solid #333',
                                ':last-of-type': {
                                  borderBottom: 'none',
                                },
                                ':active': {
                                  backgroundColor: '#2a2a2a',
                                },
                              }),
                              multiValue: (base) => ({
                                ...base,
                                backgroundColor: '#191919',
                                borderRadius: '4px',
                                border: '1px solid #454545ff',
                              }),
                              multiValueLabel: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              multiValueRemove: (base) => ({
                                ...base,
                                color: 'white',
                                ':hover': {
                                  backgroundColor: '#333',
                                  color: 'white',
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              placeholder: (base) => ({
                                ...base,
                                color: '#aaa',
                              }),

                              input: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              dropdownIndicator: (base) => ({
                                ...base,
                                color: 'white',
                                ':hover': { color: 'white' },
                              }),
                            }}
                            // value={addedMedications
                            //   .map((med) => {
                            //     const match = masterMedications?.find((m) => m.name === med.name)
                            //     return match ? { value: match.id, label: match.name, ...match } : null
                            //   })
                            //   .filter(Boolean)}
                            value={addedMedications
                              .map((med) => {
                                const match = masterMedications?.find((m) => m.name === med.name)

                                // If med exists in master → return full master object
                                if (match) {
                                  return { value: match.id, label: match.name, ...match }
                                }

                                // If med is creatable → return its own details
                                return {
                                  value: med.name, // or med.id if you generate one
                                  label: med.name,
                                  ...med,
                                }
                              })
                              .filter(Boolean)}
                            onChange={(selectedOptions) => {
                              setAddedMedications((prevMedications) => {
                                const selectedNames = selectedOptions?.map((item) => item.label)

                                const retained = prevMedications?.filter((med) => selectedNames.includes(med.name))

                                const retainedNames = retained.map((med) => med.name)

                                const newItems = selectedOptions
                                  .filter((item) => !retainedNames.includes(item.label))
                                  .map((item) => ({
                                    dosageArr: item.dosage,
                                    sideEffect: item.sideEffect,
                                    mechanismOfAction: item.mechanismOfAction,
                                    maxDose: item.maxDose,
                                    therapeuticLevels: item.therapeuticlevels,
                                    class: item.class,
                                    otherRoute: item.otherRoute,
                                    route: '',
                                    dosage: '',
                                    frequency: '',
                                    isScriptRequired: false,
                                    name: item.label,
                                    reason: '',
                                    script: [],
                                  }))

                                return [...retained, ...newItems]
                              })
                            }}
                            placeholder="Select Medication"
                            className="w-100"
                          />
                        </div>
                        <div className={`  ${role == 'provider' ? 'accordion-dark' : ' '}  `}>
                          <CAccordion alwaysOpen className="transparentAccordion">
                            {addedMedications.map((item, index) => {
                              return (
                                <CAccordionItem className="mt-2">
                                  <CAccordionHeader>
                                    <div className="d-flex align-items-center justify-content-between w-100">
                                      <p className="m-0 p-0">{item.name}</p>
                                      <span
                                        className="p-0 m-0 text-danger"
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          handleDeleteMedication(index)
                                        }}
                                      >
                                        <Trash />
                                      </span>
                                    </div>
                                  </CAccordionHeader>
                                  <CAccordionBody>
                                    <div>
                                      <div className="d-flex w-full align-items-center gap-2 flex-column">
                                        <div className="d-flex align-items-center gap-2 w-full  ">
                                          <CFormCheck
                                            checked={item.isScriptRequired}
                                            onChange={(e) => {
                                              const updatedMedications = [...addedMedications]
                                              updatedMedications[index].isScriptRequired = e.target.checked
                                              setAddedMedications(updatedMedications)
                                            }}
                                            id={`isMedicationScriptRequired${index}`}
                                            label="Does this requires a script?"
                                          />
                                          <FilePen
                                            onClick={() => {
                                              setAddScriptMedicationIndex(index)
                                            }}
                                            strokeWidth={2}
                                            size={15}
                                          />
                                        </div>
                                        <div>
                                          {!item.isCustom && (
                                            <p className="text-warning">
                                              Mechanism of Action: {item?.mechanismOfAction} | Medication Class: {item?.class} | Route: {item.otherRoute} | Side Effects: {item?.sideEffect} | Therapeutic Levels: Min: — {item?.therapeuticLevels?.min} Max: — {item?.therapeuticLevels?.max} | Max Dose:{' '}
                                              {item?.maxDose}
                                            </p>
                                          )}
                                        </div>
                                        <div className="w-100">
                                          <CFormLabel className="p-0 m-0">Dosage -</CFormLabel>
                                          <CreatableSelect
                                            onChange={(e) => {
                                              const updatedMedications = [...addedMedications]
                                              updatedMedications[index].dosage = e.value
                                              setAddedMedications(updatedMedications)
                                            }}
                                            styles={{
                                              control: (base, state) => ({
                                                ...base,
                                                backgroundColor: '#191919',
                                                borderColor: state.isFocused ? '#444' : '#444',
                                                borderRadius: '6px',
                                                boxShadow: 'none',
                                                '&:hover': {
                                                  borderColor: '#444',
                                                },
                                              }),
                                              menu: (base) => ({
                                                ...base,
                                                backgroundColor: '#000',
                                                borderRadius: '6px',
                                              }),
                                              option: (base, state) => ({
                                                ...base,
                                                backgroundColor: state.isSelected
                                                  ? '#191919' // blue for selected
                                                  : state.isFocused
                                                    ? '#2a2a2a'
                                                    : '#000',
                                                color: 'white',
                                                cursor: 'pointer',
                                                padding: '12px 14px',
                                                borderBottom: '1px solid #333',
                                                ':last-of-type': {
                                                  borderBottom: 'none',
                                                },
                                                ':active': {
                                                  backgroundColor: '#2a2a2a',
                                                },
                                              }),
                                              multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: '#191919',
                                                borderRadius: '4px',
                                                border: '1px solid #454545ff',
                                              }),
                                              multiValueLabel: (base) => ({
                                                ...base,
                                                color: 'white',
                                              }),
                                              multiValueRemove: (base) => ({
                                                ...base,
                                                color: 'white',
                                                ':hover': {
                                                  backgroundColor: '#333',
                                                  color: 'white',
                                                },
                                              }),
                                              singleValue: (base) => ({
                                                ...base,
                                                color: 'white',
                                              }),
                                              placeholder: (base) => ({
                                                ...base,
                                                color: '#aaa',
                                              }),

                                              input: (base) => ({
                                                ...base,
                                                color: 'white',
                                              }),
                                              dropdownIndicator: (base) => ({
                                                ...base,
                                                color: 'white',
                                                ':hover': { color: 'white' },
                                              }),
                                            }}
                                            options={
                                              (item?.dosageArr?.length > 0 &&
                                                item.dosageArr?.map((item) => ({
                                                  value: item,
                                                  label: item,
                                                }))) ||
                                              []
                                            }
                                            value={item.dosage ? { value: item.dosage, label: item.dosage } : null}
                                          />
                                        </div>
                                        <div className="w-100">
                                          <CFormLabel className="p-0 m-0">Frequency -</CFormLabel>
                                          <Select
                                            onChange={(e) => {
                                              const updatedMedications = [...addedMedications]
                                              updatedMedications[index].frequency = e.value
                                              setAddedMedications(updatedMedications)
                                            }}
                                            styles={{
                                              control: (base, state) => ({
                                                ...base,
                                                backgroundColor: '#191919',
                                                borderColor: state.isFocused ? '#444' : '#444',
                                                borderRadius: '6px',
                                                boxShadow: 'none',
                                                '&:hover': {
                                                  borderColor: '#444',
                                                },
                                              }),
                                              menu: (base) => ({
                                                ...base,
                                                backgroundColor: '#000',
                                                borderRadius: '6px',
                                              }),
                                              option: (base, state) => ({
                                                ...base,
                                                backgroundColor: state.isSelected
                                                  ? '#191919' // blue for selected
                                                  : state.isFocused
                                                    ? '#2a2a2a'
                                                    : '#000',
                                                color: 'white',
                                                cursor: 'pointer',
                                                padding: '12px 14px',
                                                borderBottom: '1px solid #333',
                                                ':last-of-type': {
                                                  borderBottom: 'none',
                                                },
                                                ':active': {
                                                  backgroundColor: '#2a2a2a',
                                                },
                                              }),
                                              multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: '#191919',
                                                borderRadius: '4px',
                                                border: '1px solid #454545ff',
                                              }),
                                              multiValueLabel: (base) => ({
                                                ...base,
                                                color: 'white',
                                              }),
                                              multiValueRemove: (base) => ({
                                                ...base,
                                                color: 'white',
                                                ':hover': {
                                                  backgroundColor: '#333',
                                                  color: 'white',
                                                },
                                              }),
                                              singleValue: (base) => ({
                                                ...base,
                                                color: 'white',
                                              }),
                                              placeholder: (base) => ({
                                                ...base,
                                                color: '#aaa',
                                              }),

                                              input: (base) => ({
                                                ...base,
                                                color: 'white',
                                              }),
                                              dropdownIndicator: (base) => ({
                                                ...base,
                                                color: 'white',
                                                ':hover': { color: 'white' },
                                              }),
                                            }}
                                            options={frequencyMedication || []}
                                            value={item.frequency ? { value: item.frequency, label: item.frequency } : null}
                                          />
                                        </div>
                                        <div className="w-100">
                                          <CFormLabel className="p-0 m-0">Routes -</CFormLabel>
                                          <Select
                                            onChange={(e) => {
                                              const updatedMedications = [...addedMedications]
                                              updatedMedications[index].route = e.value
                                              setAddedMedications(updatedMedications)
                                            }}
                                            styles={{
                                              control: (base, state) => ({
                                                ...base,
                                                backgroundColor: '#191919',
                                                borderColor: state.isFocused ? '#444' : '#444',
                                                borderRadius: '6px',
                                                boxShadow: 'none',
                                                '&:hover': {
                                                  borderColor: '#444',
                                                },
                                              }),
                                              menu: (base) => ({
                                                ...base,
                                                backgroundColor: '#000',
                                                borderRadius: '6px',
                                              }),
                                              option: (base, state) => ({
                                                ...base,
                                                backgroundColor: state.isSelected
                                                  ? '#191919' // blue for selected
                                                  : state.isFocused
                                                    ? '#2a2a2a'
                                                    : '#000',
                                                color: 'white',
                                                cursor: 'pointer',
                                                padding: '12px 14px',
                                                borderBottom: '1px solid #333',
                                                ':last-of-type': {
                                                  borderBottom: 'none',
                                                },
                                                ':active': {
                                                  backgroundColor: '#2a2a2a',
                                                },
                                              }),
                                              multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: '#191919',
                                                borderRadius: '4px',
                                                border: '1px solid #454545ff',
                                              }),
                                              multiValueLabel: (base) => ({
                                                ...base,
                                                color: 'white',
                                              }),
                                              multiValueRemove: (base) => ({
                                                ...base,
                                                color: 'white',
                                                ':hover': {
                                                  backgroundColor: '#333',
                                                  color: 'white',
                                                },
                                              }),
                                              singleValue: (base) => ({
                                                ...base,
                                                color: 'white',
                                              }),
                                              placeholder: (base) => ({
                                                ...base,
                                                color: '#aaa',
                                              }),

                                              input: (base) => ({
                                                ...base,
                                                color: 'white',
                                              }),
                                              dropdownIndicator: (base) => ({
                                                ...base,
                                                color: 'white',
                                                ':hover': { color: 'white' },
                                              }),
                                            }}
                                            options={routesOption || []}
                                            value={item.route ? { value: item.route, label: item.route } : null}
                                          />
                                        </div>
                                        <div className="w-100">
                                          <p>Reason -</p>

                                          <Graytextarea
                                            value={item.reason}
                                            onChange={(e) => {
                                              const updatedMedications = [...addedMedications]
                                              updatedMedications[index].reason = e.target.value
                                              setAddedMedications(updatedMedications)
                                            }}
                                            style={{
                                              backgroundColor: '#282828',
                                              color: 'white',
                                            }}
                                            height="100px"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </CAccordionBody>
                                </CAccordionItem>
                              )
                            })}
                          </CAccordion>
                        </div>
                        <CModal visible={addScriptMedicationIndex !== null} onClose={() => setAddScriptMedicationIndex(null)}>
                          {/* <CModalHeader>
                                            <CModalTitle>React Modal title</CModalTitle>
                                        </CModalHeader> */}
                          <CModalBody
                            style={{
                              background: '#191919',
                              borderRadius: '10px 10px 0 0',
                            }}
                          >
                            <CNav variant="pills" role="tablist">
                              <CNavItem>
                                {/* <CNavLink active={activeScriptTabMedication === 1} onClick={() => setActiveScriptTabMedication(1)}>
                                    Script
                                  </CNavLink> */}
                              </CNavItem>
                              {/* <CNavItem>
                                                            <CNavLink active={activeScriptTabMedication === 2} onClick={() => setActiveScriptTabMedication(2)}>
                                                                Example
                                                            </CNavLink>
                                                        </CNavItem> */}
                            </CNav>
                            <CTabContent>
                              <CTabPane role="tabpanel" aria-labelledby="home-tab" visible={activeScriptTabMedication === 1}>
                                <div className="mt-4">
                                  <DarkCloudinaryUploader
                                    onDelete={(id, fileObj) => {
                                      console.log()
                                    }}
                                    onUploadSuccess={(url) => {
                                      setAddedMedications((prev) => {
                                        const updated = [...prev]

                                        if (!updated[addScriptMedicationIndex]) return prev

                                        updated[addScriptMedicationIndex] = {
                                          ...updated[addScriptMedicationIndex],
                                          script: [...updated[addScriptMedicationIndex].script, url],
                                        }

                                        return updated
                                      })
                                    }}
                                  />
                                  <div className="d-flex items-center gap-3 mt-4">
                                    {addedMedications[addScriptMedicationIndex]?.script &&
                                      addedMedications[addScriptMedicationIndex]?.script.length > 0 &&
                                      addedMedications[addScriptMedicationIndex]?.script.map((fileUrl, fileIdx) => {
                                        const extension = fileUrl.split('.').pop()?.toLowerCase()
                                        const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)
                                        const isVideo = ['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(extension)
                                        const isDocument = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(extension)
                                        return (
                                          <div key={fileIdx} className="d-flex flex-column gap-2 align-items-center">
                                            <a
                                              href={fileUrl}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              className="shadow rounded p-2 position-relative d-block bg-white"
                                              style={{
                                                width: '100px',
                                                height: '100px',
                                                overflow: 'hidden',
                                                borderRadius: '8px',
                                                cursor: 'pointer',

                                                textDecoration: 'none',
                                              }}
                                            >
                                              {isVideo ? (
                                                <video
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    borderRadius: '8px',
                                                  }}
                                                  controls
                                                >
                                                  <source src={fileUrl} type="video/mp4" />
                                                </video>
                                              ) : isImage ? (
                                                <img
                                                  src={fileUrl}
                                                  alt="Uploaded"
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    borderRadius: '8px',
                                                  }}
                                                />
                                              ) : isDocument ? (
                                                <iframe
                                                  src={fileUrl}
                                                  title="Document Viewer"
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    border: 'none',
                                                    borderRadius: '8px',
                                                    pointerEvents: 'none',
                                                  }}
                                                />
                                              ) : (
                                                <div
                                                  className="text-center"
                                                  style={{
                                                    color: '#fff',
                                                    fontSize: '0.75rem',
                                                    padding: '10px',
                                                  }}
                                                >
                                                  Unknown File
                                                </div>
                                              )}
                                            </a>
                                          </div>
                                        )
                                      })}
                                  </div>
                                </div>
                              </CTabPane>
                              <CTabPane role="tabpanel" aria-labelledby="profile-tab" visible={activeScriptTabMedication === 2}>
                                Food truck fixie locavore, accusamus mcsweeney&#39;s marfa nulla single-origin coffee squid. Exercitation +1 labore velit, blog sartorial PBR leggings next level wes anderson artisan four loko farm-to-table craft beer twee. Qui photo booth letterpress, commodo enim
                                craft beer mlkshk aliquip jean shorts ullamco ad vinyl cillum PBR. Homo nostrud organic, assumenda labore aesthetic magna delectus mollit. Keytar helvetica VHS salvia yr, vero magna velit sapiente labore stumptown. Vegan fanny pack odio cillum wes anderson 8-bit,
                                sustainable jean shorts beard ut DIY ethical culpa terry richardson biodiesel. Art party scenester stumptown, tumblr butcher vero sint qui sapiente accusamus tattooed echo park.
                              </CTabPane>
                            </CTabContent>
                          </CModalBody>
                          <CModalFooter
                            style={{
                              backgroundColor: '#191919',
                              borderTop: '1px solid gray',
                              display: 'flex',
                              justifyContent: 'center',
                              gap: '10px',
                              padding: '10px',
                              borderRadius: '0 0 10px 10px',
                            }}
                          >
                            <CButton variant="outline" onClick={() => setAddScriptMedicationIndex(null)} color="secondary">
                              Close
                            </CButton>
                          </CModalFooter>
                        </CModal>
                      </div>
                    </CTabPane>
                    <CTabPane className="" role="tabpanel" aria-labelledby="home-tab" visible={activeTabMedication === 2}>
                      <div
                        style={{
                          height: '65vh',
                          overflow: 'auto',
                          background: '#282828',
                        }}
                      >
                        <div>
                          <p>Existing Medication</p>
                          {medicationList &&
                            medicationList?.length > 0 &&
                            medicationList.map((medEntry, index) => {
                              return (
                                <div
                                  className={'mt-4'}
                                  title={`Date: 
                                                                                ${new Date(medEntry.date).toLocaleDateString('en-US', {
                                                                                  month: '2-digit',
                                                                                  day: '2-digit',
                                                                                  year: 'numeric',
                                                                                })}
                                                                                `}
                                  key={index}
                                  style={{ borderRadius: '1rem', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', background: '#282828', border: '1px solid gray' }}
                                >
                                  <div className="p-4  text-white">
                                    <p>
                                      Date :{' '}
                                      {new Date(medEntry.date).toLocaleDateString('en-US', {
                                        month: '2-digit',
                                        day: '2-digit',
                                        year: 'numeric',
                                      })}
                                    </p>
                                    <CTable className=" text-white">
                                      <CTableHead>
                                        <CTableRow className=" text-white">
                                          <CTableHeaderCell className=" text-white">Medication Name</CTableHeaderCell>
                                          <CTableHeaderCell className=" text-white">Dosage</CTableHeaderCell>
                                          <CTableHeaderCell className=" text-white">Route</CTableHeaderCell>
                                          <CTableHeaderCell className=" text-white">Frequency</CTableHeaderCell>
                                        </CTableRow>
                                      </CTableHead>
                                      <CTableBody className="p-0">
                                        {medEntry?.data.map((med, medIndex) => (
                                          <CTableRow key={medIndex}>
                                            <CTableDataCell className=" text-white">{med.name}</CTableDataCell>
                                            <CTableDataCell className=" text-white">{med.dosage}</CTableDataCell>
                                            <CTableDataCell className=" text-white">{med.route}</CTableDataCell>
                                            <CTableDataCell className=" text-white">{med.frequency}</CTableDataCell>
                                          </CTableRow>
                                        ))}
                                      </CTableBody>
                                    </CTable>
                                  </div>
                                </div>
                              )
                            })}
                        </div>
                        <div className="mt-3">
                          <p>Existing Orders</p>
                          <div>
                            <div className="  rounded   " style={{ background: '#282828' }}>
                              {order?.length > 0 ? (
                                order.map((item, idx) => {
                                  const currentOrder = item?.medication
                                  return (
                                    <div key={idx} className="mb-3" style={{ background: '#282828', border: '1px solid gray', borderRadius: '10px' }}>
                                      <div className=" shadow-sm  ">
                                        <div className="card-body">
                                          {/* Date */}
                                          <div className="">
                                            <div>
                                              <CFormLabel className="me-2 fw-bold">Date :</CFormLabel>
                                              {(() => {
                                                const rawDate = item?.date
                                                if (!rawDate) return ''

                                                const parts = rawDate.split('-')
                                                if (parts.length !== 3) return ''

                                                const [day, month, year] = parts

                                                // Check for numeric validity
                                                if (isNaN(Number(day)) || isNaN(Number(month)) || isNaN(Number(year))) return ''

                                                // Month in JS is 0-based when using `new Date(year, monthIndex, day)`
                                                const date = new Date(Number(year), Number(month) - 1, Number(day))

                                                if (isNaN(date.getTime())) return '' // Invalid date

                                                return new Intl.DateTimeFormat('en-US', {
                                                  day: '2-digit',
                                                  month: '2-digit',
                                                  year: 'numeric',
                                                }).format(date)
                                              })()}
                                            </div>
                                            {currentOrder?.diagnosis && (
                                              <p className="mb-1 " style={{ marginTop: '-8px' }}>
                                                <strong>Diagnosis:</strong> {currentOrder.diagnosis}
                                              </p>
                                            )}
                                          </div>

                                          {currentOrder?.medication?.medication?.length > 0 && (
                                            <div className="mb-2" style={{ background: '#282828' }}>
                                              <p className="  fw-bold mb-1">Medications</p>
                                              <ul>
                                                {currentOrder.medication.medication.map((medItem, mIdx) => (
                                                  <li className="p-0 m-0 text-white" key={mIdx}>
                                                    {medItem?.name} {medItem?.dosage} {medItem?.route}
                                                    {medItem?.frequency && ` ${medItem.frequency}`}
                                                    {medItem?.reason && ` - ${medItem.reason}`}
                                                  </li>
                                                ))}
                                              </ul>
                                            </div>
                                          )}

                                          {/* {currentOrder?.imaging?.imagingTypes?.length > 0 && (
                                                                                                <div className="mb-2">
                                                                                                    <p className="text-secondary fw-bold mb-1">Imaging</p>
                                                                                                    <ul>
                                                                                                        {currentOrder.imaging.imagingTypes?.filter(item=>item?.type).map((imagingItem, iIdx) => (
                                                                                                            <li className="p-0 m-0" key={iIdx}>
                                                                                                                {imagingItem?.type}
                                                                                                            </li>
                                                                                                        ))}
                                                                                                    </ul>
                                                                                                </div>
                                                                                            )} */}

                                          {/* {currentOrder?.lab?.labs?.length > 0 && (
                                                                                                <div className="mb-2">
                                                                                                    <p className="text-secondary fw-bold mb-1">Labs</p>
                                                                                                    <ul>
                                                                                                        {currentOrder.lab.labs.map((labItem, lIdx) => (
                                                                                                            <li className="p-0 m-0" key={lIdx}>
                                                                                                                {labItem?.lab}
                                                                                                                {labItem?.reason && ` - Reason for ${labItem.lab}: ${labItem.reason}`}
                                                                                                            </li>
                                                                                                        ))}
                                                                                                    </ul>
                                                                                                </div>
                                                                                            )}
                                                    
                                                    
                                                                                            {currentOrder?.miscellaneous?.miscellaneous?.length > 0 && (
                                                                                                <div className="mb-2">
                                                                                                    <p className="text-secondary fw-bold mb-1">Miscellaneous</p>
                                                                                                    <ul>
                                                                                                        {currentOrder.miscellaneous.miscellaneous.map((miscItem, xIdx) => (
                                                                                                            <li className="p-0 m-0" key={xIdx}>
                                                                                                                {miscItem}
                                                                                                            </li>
                                                                                                        ))}
                                                                                                    </ul>
                                                                                                </div>
                                                                                            )} */}
                                        </div>
                                      </div>
                                    </div>
                                  )
                                })
                              ) : (
                                <div className="text-center text-muted py-3">No orders available.</div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </CTabPane>
                  </CTabContent>
                </CTabPane>
                <CTabPane className="px-3 order-tab-content" role="tabpanel" aria-labelledby="home-tab" visible={activeTab === 3}>
                  <div className="d-flex gap-2 justify-content-center">
                    <div
                      onClick={() => setActiveTabLabs(1)}
                      style={{
                        cursor: 'pointer',
                        backgroundColor: activeTabLabs === 1 ? '#4363F2' : '#282828',
                        border: '1px solid #989898',
                        padding: '5px 14px',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                        color: '#fff',
                        fontWeight: '500',
                        fontSize: '14px',
                        boxShadow: 'none',
                        width: '100px',
                      }}
                    >
                      Add
                    </div>

                    <div
                      onClick={() => setActiveTabLabs(2)}
                      style={{
                        cursor: 'pointer',
                        backgroundColor: activeTabLabs === 2 ? '#4363F2' : '#282828',
                        border: '1px solid #989898',
                        padding: '5px 14px',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                        color: '#fff',
                        fontWeight: '500',
                        fontSize: '14px',
                        boxShadow: 'none',
                        width: '100px',
                      }}
                    >
                      List
                    </div>
                  </div>
                  <CTabContent className="p-2">
                    <CTabPane role="tabpanel" aria-labelledby="home-tab" visible={activeTabLabs === 1}>
                      <div className="w-100 d-flex flex-column gap-2" style={{ overflow: 'scroll', height: '65vh' }}>
                        {/* Lab Selection */}
                        <div className="">
                          <p className="p-0 mb-2">Labs</p>
                          <Select
                            isMulti={true}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                backgroundColor: '#191919',
                                borderColor: state.isFocused ? '#444' : '#444',
                                borderRadius: '6px',
                                boxShadow: 'none',
                                '&:hover': {
                                  borderColor: '#444',
                                },
                              }),
                              menu: (base) => ({
                                ...base,
                                backgroundColor: '#000',
                                borderRadius: '6px',
                              }),
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected
                                  ? '#191919' // blue for selected
                                  : state.isFocused
                                    ? '#2a2a2a'
                                    : '#000',
                                color: 'white',
                                cursor: 'pointer',
                                padding: '12px 14px',
                                borderBottom: '1px solid #333',
                                ':last-of-type': {
                                  borderBottom: 'none',
                                },
                                ':active': {
                                  backgroundColor: '#2a2a2a',
                                },
                              }),
                              multiValue: (base) => ({
                                ...base,
                                backgroundColor: '#191919',
                                borderRadius: '4px',
                                border: '1px solid #454545ff',
                              }),
                              multiValueLabel: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              multiValueRemove: (base) => ({
                                ...base,
                                color: 'white',
                                ':hover': {
                                  backgroundColor: '#333',
                                  color: 'white',
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              placeholder: (base) => ({
                                ...base,
                                color: '#aaa',
                              }),

                              input: (base) => ({
                                ...base,
                                color: 'white',
                              }),
                              dropdownIndicator: (base) => ({
                                ...base,
                                color: 'white',
                                ':hover': { color: 'white' },
                              }),
                            }}
                            options={masterLabs.map((item) => ({
                              value: item.ID,
                              label: item.LabName,
                            }))}
                            value={addedLabs
                              .map((lab) => {
                                const match = masterLabs.find((m) => m.LabName === lab.lab)
                                return match ? { value: match.ID, label: match.LabName } : null
                              })
                              .filter(Boolean)}
                            onChange={(selectedOptions) => {
                              setAddedLabs((prevLabs) => {
                                const selectedLabels = selectedOptions.map((item) => item.label)

                                // Retain existing labs that are still selected
                                const retained = prevLabs.filter((lab) => selectedLabels.includes(lab.lab))

                                // Add new labs that weren't previously selected
                                const retainedTypes = retained.map((lab) => lab.lab)
                                const newItems = selectedLabels
                                  .filter((label) => !retainedTypes.includes(label))
                                  .map((label) => ({
                                    lab: label,
                                    isScriptRequired: false,
                                    reason: '',
                                    script: [],
                                  }))

                                return [...retained, ...newItems]
                              })
                            }}
                            placeholder="Select Labs"
                            className="w-100"
                          />
                        </div>

                        {/* Lab Accordion List */}
                        <div className={`  ${role == 'provider' ? 'accordion-dark' : ' '}  `}>
                          <CAccordion alwaysOpen className="transparentAccordion">
                            {addedLabs.map((item, index) => (
                              <CAccordionItem key={index} className="mt-2">
                                <CAccordionHeader>{item.lab}</CAccordionHeader>
                                <CAccordionBody>
                                  <div>
                                    <div className="d-flex align-items-center gap-2">
                                      <CFormCheck
                                        checked={item.isScriptRequired}
                                        onChange={(e) => {
                                          const updatedLabs = [...addedLabs]
                                          updatedLabs[index].isScriptRequired = e.target.checked
                                          setAddedLabs(updatedLabs)
                                        }}
                                        id={`isScriptRequiredLab${index}`}
                                        label="Does this require a script?"
                                      />
                                      <FilePen onClick={() => setAddScriptLabsIndex(index)} strokeWidth={2} size={15} />
                                    </div>
                                    <p>Reason -</p>
                                    <Graytextarea
                                      value={item.reason}
                                      onChange={(e) => {
                                        const updatedLabs = [...addedLabs]
                                        updatedLabs[index].reason = e.target.value
                                        setAddedLabs(updatedLabs)
                                      }}
                                      height="100px"
                                    />
                                  </div>
                                </CAccordionBody>
                              </CAccordionItem>
                            ))}
                          </CAccordion>
                        </div>

                        {/* Lab Script Modal */}
                        <CModal visible={addScriptLabsIndex !== null} onClose={() => setAddScriptLabsIndex(null)}>
                          <CModalBody
                            style={{
                              background: '#191919',
                              borderRadius: '10px 10px 0 0',
                            }}
                          >
                            <CNav variant="pills" role="tablist">
                              <CNavItem>
                                {/* <CNavLink active={activeScriptTabLabs === 1} onClick={() => setActiveScriptTabLabs(1)}>
                                    Script
                                  </CNavLink> */}
                              </CNavItem>
                              {/* <CNavItem>
                                                            <CNavLink
                                                                active={activeScriptTabLabs === 2}
                                                                onClick={() => setActiveScriptTabLabs(2)}
                                                            >
                                                                Example
                                                            </CNavLink>
                                                        </CNavItem> */}
                            </CNav>

                            <CTabContent>
                              <CTabPane role="tabpanel" aria-labelledby="home-tab" visible={activeScriptTabLabs === 1}>
                                <div className="mt-4">
                                  <DarkCloudinaryUploader
                                    onDelete={(id, fileObj) => console.log()}
                                    onUploadSuccess={(result) => {
                                      const updatedLabs = [...addedLabs]
                                      updatedLabs[addScriptLabsIndex].script = [...(updatedLabs[addScriptLabsIndex].script || []), result]
                                      setAddedLabs(updatedLabs)
                                    }}
                                  />
                                  <div className="d-flex items-center gap-3 mt-4">
                                    {addedLabs[addScriptLabsIndex]?.script?.map((fileUrl, fileIdx) => {
                                      const extension = fileUrl.split('.').pop()?.toLowerCase()
                                      const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)
                                      const isVideo = ['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(extension)
                                      const isDocument = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(extension)
                                      return (
                                        <div key={fileIdx} className="d-flex flex-column gap-2 align-items-center">
                                          <a
                                            href={fileUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="shadow rounded p-2 position-relative d-block bg-white"
                                            style={{
                                              width: '100px',
                                              height: '100px',
                                              overflow: 'hidden',
                                              borderRadius: '8px',
                                              cursor: 'pointer',

                                              textDecoration: 'none',
                                            }}
                                          >
                                            {isVideo ? (
                                              <video
                                                style={{
                                                  width: '100%',
                                                  height: '100%',
                                                  objectFit: 'cover',
                                                  borderRadius: '8px',
                                                }}
                                                controls
                                              >
                                                <source src={fileUrl} type="video/mp4" />
                                              </video>
                                            ) : isImage ? (
                                              <img
                                                src={fileUrl}
                                                alt="Uploaded"
                                                style={{
                                                  width: '100%',
                                                  height: '100%',
                                                  objectFit: 'cover',
                                                  borderRadius: '8px',
                                                }}
                                              />
                                            ) : isDocument ? (
                                              <iframe
                                                src={fileUrl}
                                                title="Document Viewer"
                                                style={{
                                                  width: '100%',
                                                  height: '100%',
                                                  border: 'none',
                                                  borderRadius: '8px',
                                                  pointerEvents: 'none',
                                                }}
                                              />
                                            ) : (
                                              <div
                                                className="text-center"
                                                style={{
                                                  color: '#fff',
                                                  fontSize: '0.75rem',
                                                  padding: '10px',
                                                }}
                                              >
                                                Unknown File
                                              </div>
                                            )}
                                          </a>
                                        </div>
                                      )
                                    })}
                                  </div>
                                </div>
                              </CTabPane>

                              <CTabPane role="tabpanel" aria-labelledby="profile-tab" visible={activeScriptTabLabs === 2}>
                                {/* Example content for labs */}
                                <p>Example lab requisition content would go here...</p>
                              </CTabPane>
                            </CTabContent>
                          </CModalBody>
                          <CModalFooter
                            style={{
                              backgroundColor: '#191919',
                              borderTop: '1px solid gray',
                              display: 'flex',
                              justifyContent: 'center',
                              gap: '10px',
                              padding: '10px',
                              borderRadius: '0 0 10px 10px',
                            }}
                          >
                            <CButton variant="outline" onClick={() => setAddScriptLabsIndex(null)} color="secondary">
                              Close
                            </CButton>
                          </CModalFooter>
                        </CModal>
                      </div>
                    </CTabPane>
                    <CTabPane className="" role="tabpanel" aria-labelledby="home-tab" visible={activeTabLabs === 2}>
                      <div
                        style={{
                          height: '65vh',
                          overflow: 'auto',
                        }}
                      >
                        <div>
                          <p>Existing Labs</p>
                          <div>
                            {allLabs &&
                              allLabs.map((labEntry, index) => {
                                return (
                                  <div
                                    key={index}
                                    className=""
                                    title={`Date: ${new Date(labEntry.date).toLocaleDateString('en-US', {
                                      month: '2-digit',
                                      day: '2-digit',
                                      year: 'numeric',
                                    })}`}
                                    style={{ borderRadius: '1rem', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', border: '1px solid gray' }}
                                  >
                                    <div className="p-3 " style={{ width: '120%' }}>
                                      <p>
                                        Date:{' '}
                                        {new Date(labEntry.date).toLocaleDateString('en-US', {
                                          month: '2-digit',
                                          day: '2-digit',
                                          year: 'numeric',
                                        })}
                                      </p>
                                      <CTable className="table" style={{ tableLayout: 'fixed' }} responsive>
                                        <CTableHead>
                                          <CTableRow>
                                            <CTableHeaderCell style={{ width: '90px', color: 'white' }}>Lab Name</CTableHeaderCell>
                                            <CTableHeaderCell style={{ width: '70px', color: 'white' }}>Value</CTableHeaderCell>
                                            <CTableHeaderCell style={{ width: '70px', color: 'white' }}>Unit</CTableHeaderCell>
                                            <CTableHeaderCell style={{ width: '100px', color: 'white' }}>Range</CTableHeaderCell>
                                            <CTableHeaderCell style={{ width: '200px', color: 'white' }}>Diagnosis</CTableHeaderCell>
                                            <CTableHeaderCell style={{ width: '200px', color: 'white' }}>Remark</CTableHeaderCell>
                                          </CTableRow>
                                        </CTableHead>
                                        <CTableBody>
                                          {labEntry.data?.map((lab, labIndex) => (
                                            <CTableRow key={labIndex}>
                                              <CTableDataCell className="text-white">{lab.name}</CTableDataCell>
                                              <CTableDataCell className="text-white">{lab.value || '-'}</CTableDataCell>
                                              <CTableDataCell className="text-white">{lab.unit}</CTableDataCell>
                                              <CTableDataCell className="text-white">{lab.range}</CTableDataCell>
                                              <CTableDataCell className="text-white">{lab.diagnosis}</CTableDataCell>
                                              <CTableDataCell className="text-white">{lab.remark}</CTableDataCell>
                                            </CTableRow>
                                          ))}
                                        </CTableBody>
                                      </CTable>
                                    </div>
                                  </div>
                                )
                              })}
                          </div>
                        </div>
                        <div className="mt-3">
                          <p>Existing Orders</p>
                          <div>
                            <div className=" rounded   ">
                              {order?.length > 0 ? (
                                order.map((item, idx) => {
                                  const currentOrder = item?.medication
                                  return (
                                    <div key={idx} className="mb-3">
                                      <div className="  shadow-sm    " style={{ border: '1px solid gray', borderRadius: '10px' }}>
                                        <div className="card-body">
                                          {/* Date */}
                                          <div className="">
                                            <div>
                                              <CFormLabel className="me-2 fw-bold">Date :</CFormLabel>
                                              {(() => {
                                                const rawDate = item?.date
                                                if (!rawDate) return ''

                                                const parts = rawDate.split('-')
                                                if (parts.length !== 3) return ''

                                                const [day, month, year] = parts

                                                // Check for numeric validity
                                                if (isNaN(Number(day)) || isNaN(Number(month)) || isNaN(Number(year))) return ''

                                                // Month in JS is 0-based when using `new Date(year, monthIndex, day)`
                                                const date = new Date(Number(year), Number(month) - 1, Number(day))

                                                if (isNaN(date.getTime())) return '' // Invalid date

                                                return new Intl.DateTimeFormat('en-US', {
                                                  day: '2-digit',
                                                  month: '2-digit',
                                                  year: 'numeric',
                                                }).format(date)
                                              })()}
                                            </div>
                                            {currentOrder?.diagnosis && (
                                              <p className="mb-1 " style={{ marginTop: '-8px' }}>
                                                <strong>Diagnosis:</strong> {currentOrder.diagnosis}
                                              </p>
                                            )}
                                          </div>

                                          {currentOrder?.lab?.labs?.length > 0 && (
                                            <div className="mb-2">
                                              <p className="text-secondary fw-bold mb-1">Labs</p>
                                              <ul>
                                                {currentOrder.lab.labs.map((labItem, lIdx) => (
                                                  <li className="p-0 m-0" key={lIdx}>
                                                    {labItem?.lab}
                                                    {labItem?.reason && ` - Reason for ${labItem.lab}: ${labItem.reason}`}
                                                  </li>
                                                ))}
                                              </ul>
                                            </div>
                                          )}

                                          {/* {currentOrder?.imaging?.imagingTypes?.length > 0 && (
                                                                                                <div className="mb-2">
                                                                                                    <p className="text-secondary fw-bold mb-1">Imaging</p>
                                                                                                    <ul>
                                                                                                        {currentOrder.imaging.imagingTypes?.filter(item=>item?.type).map((imagingItem, iIdx) => (
                                                                                                            <li className="p-0 m-0" key={iIdx}>
                                                                                                                {imagingItem?.type}
                                                                                                            </li>
                                                                                                        ))}
                                                                                                    </ul>
                                                                                                </div>
                                                                                            )} */}

                                          {/* {currentOrder?.lab?.labs?.length > 0 && (
                                                                                                <div className="mb-2">
                                                                                                    <p className="text-secondary fw-bold mb-1">Labs</p>
                                                                                                    <ul>
                                                                                                        {currentOrder.lab.labs.map((labItem, lIdx) => (
                                                                                                            <li className="p-0 m-0" key={lIdx}>
                                                                                                                {labItem?.lab}
                                                                                                                {labItem?.reason && ` - Reason for ${labItem.lab}: ${labItem.reason}`}
                                                                                                            </li>
                                                                                                        ))}
                                                                                                    </ul>
                                                                                                </div>
                                                                                            )}
                                                    
                                                    
                                                                                            {currentOrder?.miscellaneous?.miscellaneous?.length > 0 && (
                                                                                                <div className="mb-2">
                                                                                                    <p className="text-secondary fw-bold mb-1">Miscellaneous</p>
                                                                                                    <ul>
                                                                                                        {currentOrder.miscellaneous.miscellaneous.map((miscItem, xIdx) => (
                                                                                                            <li className="p-0 m-0" key={xIdx}>
                                                                                                                {miscItem}
                                                                                                            </li>
                                                                                                        ))}
                                                                                                    </ul>
                                                                                                </div>
                                                                                            )} */}
                                        </div>
                                      </div>
                                    </div>
                                  )
                                })
                              ) : (
                                <div className="text-center text-muted py-3">No orders available.</div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </CTabPane>
                  </CTabContent>
                </CTabPane>
                <CTabPane className="px-3 order-tab-content" role="tabpanel" aria-labelledby="home-tab" visible={activeTab === 4}>
                  {activeTab === 4 && (
                    <div className="w-100 d-flex flex-column gap-2" style={{ overflow: 'scroll', height: '65vh' }}>
                      <div className="">
                        <p className="p-0 mb-2">Miscellaneous</p>
                        <Select
                          isMulti={true}
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              backgroundColor: '#191919',
                              borderColor: state.isFocused ? '#444' : '#444',
                              borderRadius: '6px',
                              boxShadow: 'none',
                              '&:hover': {
                                borderColor: '#444',
                              },
                            }),
                            menu: (base) => ({
                              ...base,
                              backgroundColor: '#000',
                              borderRadius: '6px',
                            }),
                            option: (base, state) => ({
                              ...base,
                              backgroundColor: state.isSelected
                                ? '#191919' // blue for selected
                                : state.isFocused
                                  ? '#2a2a2a'
                                  : '#000',
                              color: 'white',
                              cursor: 'pointer',
                              padding: '12px 14px',
                              borderBottom: '1px solid #333',
                              ':last-of-type': {
                                borderBottom: 'none',
                              },
                              ':active': {
                                backgroundColor: '#2a2a2a',
                              },
                            }),
                            multiValue: (base) => ({
                              ...base,
                              backgroundColor: '#191919',
                              borderRadius: '4px',
                              border: '1px solid #454545ff',
                            }),
                            multiValueLabel: (base) => ({
                              ...base,
                              color: 'white',
                            }),
                            multiValueRemove: (base) => ({
                              ...base,
                              color: 'white',
                              ':hover': {
                                backgroundColor: '#333',
                                color: 'white',
                              },
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color: 'white',
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: '#aaa',
                            }),

                            input: (base) => ({
                              ...base,
                              color: 'white',
                            }),
                            dropdownIndicator: (base) => ({
                              ...base,
                              color: 'white',
                              ':hover': { color: 'white' },
                            }),
                          }}
                          options={masterMiscellous.map((item) => ({
                            value: item.Id,
                            label: item.name,
                          }))}
                          value={addedMisc
                            .map((miscc) => {
                              const match = masterMiscellous.find((m) => m.name === miscc)
                              return match ? { value: match.Id, label: match.name } : null
                            })
                            .filter(Boolean)}
                          onChange={(selectedOptions) => {
                            const selectedLabels = selectedOptions.map((item) => item.label)
                            const uniqueLabels = Array.from(new Set(selectedLabels))
                            setAddedMisc(uniqueLabels)
                          }}
                          placeholder="Select Miscellaneous"
                          className="w-100"
                        />
                      </div>

                      {/* Lab Accordion List */}
                      <div className={`  ${role == 'provider' ? 'accordion-dark' : ' '}  `}>
                        <CAccordion alwaysOpen className="transparentAccordion">
                          {addedMisc.map((item, index) => (
                            <CAccordionItem key={index} className="mt-2">
                              <CAccordionHeader>{item}</CAccordionHeader>
                              <CAccordionBody>
                                <div>
                                  <div className="d-flex align-items-center gap-2">
                                    <CFormCheck
                                      checked={item.isScriptRequired}
                                      onChange={(e) => {
                                        const updatedMisc = [...addedMisc]
                                        updatedMisc[index].isScriptRequired = e.target.checked
                                        setAddedMisc(updatedMisc)
                                      }}
                                      id={`isScriptRequiredLab${index}`}
                                      label="Does this require a script?"
                                    />
                                    <FilePen onClick={() => setAddScriptLabsIndex(index)} strokeWidth={2} size={15} />
                                  </div>
                                  <p>Reason -</p>
                                  <Graytextarea
                                    value={item.reason}
                                    onChange={(e) => {
                                      const updatedMisc = [...addedMisc]
                                      updatedMisc[index].reason = e.target.value
                                      setAddedMisc(updatedMisc)
                                    }}
                                    height="100px"
                                  />
                                </div>
                              </CAccordionBody>
                            </CAccordionItem>
                          ))}
                        </CAccordion>
                      </div>

                      {/* Lab Script Modal */}
                      <CModal visible={addScriptLabsIndex !== null} onClose={() => setAddScriptLabsIndex(null)}>
                        <CModalBody>
                          <CNav variant="pills" role="tablist">
                            <CNavItem>
                              <CNavLink active={activeScriptTabLabs === 1} onClick={() => setActiveScriptTabLabs(1)}>
                                Script
                              </CNavLink>
                            </CNavItem>
                            {/* <CNavItem>
                                                        <CNavLink
                                                            active={activeScriptTabLabs === 2}
                                                            onClick={() => setActiveScriptTabLabs(2)}
                                                        >
                                                            Example
                                                        </CNavLink>
                                                    </CNavItem> */}
                          </CNav>

                          <CTabContent>
                            <CTabPane role="tabpanel" aria-labelledby="home-tab" visible={activeScriptTabLabs === 1}>
                              <div className="mt-4">
                                <DarkCloudinaryUploader
                                  onDelete={(id, fileObj) => console.log(id, fileObj)}
                                  onUploadSuccess={(result) => {
                                    const updatedLabs = [...addedLabs]
                                    updatedLabs[addScriptLabsIndex].script = [...(updatedLabs[addScriptLabsIndex].script || []), result]
                                    setAddedLabs(updatedLabs)
                                  }}
                                />
                                <div className="d-flex items-center gap-3 mt-4">
                                  {addedLabs[addScriptLabsIndex]?.script?.map((item, idx) => (
                                    <div
                                      key={idx}
                                      style={{
                                        height: '120px',
                                        width: '120px',
                                        overflow: 'hidden',
                                        objectFit: 'fill',
                                      }}
                                    >
                                      <img src={item} className="w-100 h-100" alt="" />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </CTabPane>

                            <CTabPane role="tabpanel" aria-labelledby="profile-tab" visible={activeScriptTabLabs === 2}>
                              {/* Example content for labs */}
                              <p>Example lab requisition content would go here...</p>
                            </CTabPane>
                          </CTabContent>
                        </CModalBody>
                        <CModalFooter>
                          <CButton variant="outline" onClick={() => setAddScriptLabsIndex(null)} color="secondary">
                            Close
                          </CButton>
                        </CModalFooter>
                      </CModal>
                    </div>
                  )}
                </CTabPane>
              </CTabContent>
            </div>
          </div>
        </div>
      </CModalBody>
      <CModalFooter
        style={{
          backgroundColor: '#282828',
          borderTop: '1px solid gray',
          display: 'flex',
          justifyContent: 'center',
          gap: '10px',
          padding: '10px',
        }}
      >
        <CButton
          style={{
            backgroundColor: '#333',
            border: '1px solid gray',
            color: 'white',
            borderRadius: '6px',
            padding: '8px 20px',
          }}
          variant="outline"
          onClick={reset}
          color="secondary"
        >
          Close
        </CButton>
        <CButton
          style={{
            backgroundColor: '#4363F2',
            border: 'none',
            color: 'white',
            borderRadius: '6px',
            padding: '8px 20px',
          }}
          variant="outline"
          onClick={handleSubmit}
        >
          Save Changes
        </CButton>
      </CModalFooter>
    </>
  )
}

export default AddOrders
